import React from 'react';
import {Stack} from '@mui/material';
import BackBarSingleVoyage from "@containers/singleVoyage/views/backBar/BackBarSingleVoyage";
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import {useGetByIdSingleVoyageQuery} from "@containers/singleVoyage/fetchingData/queryHooks/useSingleVoyagesQuery";
import TemplateBadgeSingleVoyage from "@containers/singleVoyage/voyageTemplates/badge/TemplateBadgeSingleVoyage";
import {
    useOutdatedVoyagesSingleVoyage
} from "@containers/singleVoyage/voyageTemplates/hooks/useOutdatedVoyagesSingleVoyage";

const BackBarMutateSingleVoyage = () => {

    const {
        routeInfo,
        voyageId,
        accountId,
    } = useRootContextMutateSingleVoyage()

    // already in the cache: the update page loaded the voyage before opening the editor
    const {data: voyage} = useGetByIdSingleVoyageQuery({
        params: {
            voyageId,
            accountId,
        },
    })

    const outdatedVoyageIds = useOutdatedVoyagesSingleVoyage({
        accountId,
        voyages: voyage ? [{id: voyage.id, voyageTemplateId: voyage.voyageTemplateId, status: voyage.voyageStatus}] : [],
    })

    return (
        <Stack direction={'row'} alignItems={'center'} gap={'8px'} minWidth={0}>
            <BackBarSingleVoyage name={routeInfo?.title}/>

            {voyageId && <TemplateBadgeSingleVoyage
                voyageTemplateId={voyage?.voyageTemplateId}
                templateDiverged={voyage?.templateDiverged}
                accountId={accountId}
                outdated={outdatedVoyageIds.has(voyageId)}
                iconOnly
            />}
        </Stack>
    );
};

export default BackBarMutateSingleVoyage;
